
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91_91id_93_9319htrayCNTex9aPfumHcKsBc_34JP8vSpIBtLFEu3CEMeta } from "/home/runner/work/1/s/frontend/pages/admin/employers/manage/[[id]].vue?macro=true";
import { default as create5719UJD_j88x9dB2Dh007lz1sfQY9sA__BT3Mrgma8kMeta } from "/home/runner/work/1/s/frontend/pages/admin/articles/create.vue?macro=true";
import { default as createucTY852iLmN7D4_SLHyljo4VH5jqiKRRGjZEliO6ZYgMeta } from "/home/runner/work/1/s/frontend/pages/admin/competencies/create.vue?macro=true";
import { default as createIm_GiVlA_nUukvIm1vc6GgXzkFDhO6Mfnhnsa565tEEMeta } from "/home/runner/work/1/s/frontend/pages/admin/employees/create.vue?macro=true";
import { default as createtMm_2tqsj5RynMocEzlUc25YnyBSQQG3z8q_BE40PhYMeta } from "/home/runner/work/1/s/frontend/pages/admin/modules/create.vue?macro=true";
import { default as createDMot9l4hjglFEAPOYpgVPdSNfDuQF10RmihJcTu9YDQMeta } from "/home/runner/work/1/s/frontend/pages/admin/profiles/create.vue?macro=true";
import { default as createLDN0qRYUp_bpptTvYdNHw_A66REkUV4ub_DriQh_aqoMeta } from "/home/runner/work/1/s/frontend/pages/admin/service-alerts/create.vue?macro=true";
import { default as createt5DLF3TO1ouiXVSRq1pIApeOAyPf_8rgjqglBRsar9sMeta } from "/home/runner/work/1/s/frontend/pages/admin/teams/create.vue?macro=true";
import { default as create_mt_0LE8ygHxRaXz9PasHnzi1RB_KJlOsSLZHrUrVqEMeta } from "/home/runner/work/1/s/frontend/pages/admin/themes/create.vue?macro=true";
import { default as updateL4vPeULsxOspvgpGBXbc1jwIm1eW_bXOKcAzrdnClKYMeta } from "/home/runner/work/1/s/frontend/pages/admin/articles/[id]/update.vue?macro=true";
import { default as update_45contentf8xFqXEWXWcktZO3bB_ZlbTbC0m0WL6QqVWwusz7hpMMeta } from "/home/runner/work/1/s/frontend/pages/admin/articles/[id]/update-content.vue?macro=true";
import { default as updateCrUw6Ydki3oqvO_Ul1K2N_N_Le_n_LtJU47J1Id1LNwMeta } from "/home/runner/work/1/s/frontend/pages/admin/employees/[id]/update.vue?macro=true";
import { default as update9kI3dhelXjvJnJZKs1TqB63gotfBYSjRADqoapJPFTcMeta } from "/home/runner/work/1/s/frontend/pages/admin/profiles/[id]/update.vue?macro=true";
import { default as updateCoyWAe55kSjjDw_sF0uQBVpWFMRY1nztCmnfA88McwsMeta } from "/home/runner/work/1/s/frontend/pages/admin/teams/[id]/update.vue?macro=true";
import { default as updateKqhZl7xNHjgVSb4FGm2qTTkckPTLzqVrc8SASASgIOAMeta } from "/home/runner/work/1/s/frontend/pages/admin/themes/[id]/update.vue?macro=true";
import { default as indexwD58owSLlYnze579DZ4pxNp9mWhf3VKw6nF2Ynecpc4Meta } from "/home/runner/work/1/s/frontend/pages/admin/articles/[id]/index.vue?macro=true";
import { default as indexHWvCM0ZjVjfK4f_ir7rEN2Uvc6IbpjkHPsOFgES5LUwMeta } from "/home/runner/work/1/s/frontend/pages/admin/competencies/[id]/index.vue?macro=true";
import { default as indexO4WW5nBlpaRi5XAD6s52DlIDN33x03D562lNF6qx8ZwMeta } from "/home/runner/work/1/s/frontend/pages/admin/employees/[id]/index.vue?macro=true";
import { default as index2HTT_eeiz_MuD_pY2q9nj8v53mnUmBmTTE2nj2sSSAoMeta } from "/home/runner/work/1/s/frontend/pages/admin/employers/[id]/index.vue?macro=true";
import { default as indexc5V7nIPe2j_CJZsk8BzmV_vNpIyNVqRynjlJ3eOIZoMMeta } from "/home/runner/work/1/s/frontend/pages/admin/modules/[id]/index.vue?macro=true";
import { default as index8q28sfFpKtAJr1_YEHhzn7FIuQNklZZwu3qmAftdbB0Meta } from "/home/runner/work/1/s/frontend/pages/admin/profiles/[id]/index.vue?macro=true";
import { default as indexl__6rYYdaIiVbJJ5j7VlOCAqJCNcvilfsGXK6iwYNmgMeta } from "/home/runner/work/1/s/frontend/pages/admin/teams/[id]/index.vue?macro=true";
import { default as indexKOp6Bd0y9sPqxrrAJxqYMv9rp7T8CP5kmGEA9EticZUMeta } from "/home/runner/work/1/s/frontend/pages/admin/themes/[id]/index.vue?macro=true";
import { default as indexIkSIVMe27bJcx9VN_xTXtyG_vwAG8T0qIVOo2a_KVGwMeta } from "/home/runner/work/1/s/frontend/pages/admin/articles/index.vue?macro=true";
import { default as certificatesO5wrK9b9aehFBmfxrrCcB_9u7vd9nAmijeLQPaz8yosMeta } from "/home/runner/work/1/s/frontend/pages/admin/certificates.vue?macro=true";
import { default as indexeV2abE7w_QTH4_NnNMs6DktPBHoFQojuYIqWVBac6kQMeta } from "/home/runner/work/1/s/frontend/pages/admin/competencies/index.vue?macro=true";
import { default as dashboardhT4IDVJtvjBhBa4NDjaQcWXYi08m6yNhty0cIYodynAMeta } from "/home/runner/work/1/s/frontend/pages/admin/dashboard.vue?macro=true";
import { default as indexcmHGB_jQnT8FpJJOGplDtLXkb5ESYi45Q7tzJKdT3k4Meta } from "/home/runner/work/1/s/frontend/pages/admin/employees/index.vue?macro=true";
import { default as indexLV0afBeYJV03aQY_rw7IG_oOM6o6SDZAy2kuSwXtSQUMeta } from "/home/runner/work/1/s/frontend/pages/admin/employers/index.vue?macro=true";
import { default as faqmLegsHaIQrjySbLMqYvSOiYtxkm2dAgWFa2zxWuqUVsMeta } from "/home/runner/work/1/s/frontend/pages/admin/faq.vue?macro=true";
import { default as indexR04DT8Ex0ZuH4jxTMFoZ4H51YWXY12hB3WllPRuKxRsMeta } from "/home/runner/work/1/s/frontend/pages/admin/lamark/index.vue?macro=true";
import { default as indexywIAgmhnenu3qTqDwCoQ_fAe8PJ0QIv05CjtixOZZxgMeta } from "/home/runner/work/1/s/frontend/pages/admin/modules/index.vue?macro=true";
import { default as my_45employerp_WFBqRPkN4z5HyGs8DX7Lp9sObbPr8_eLSTG_81AX4Meta } from "/home/runner/work/1/s/frontend/pages/admin/my-employer.vue?macro=true";
import { default as indexaXzVoCJV4AOP7RSaF6AkZZRXGjZ5CV0CWhTYC_KyeBYMeta } from "/home/runner/work/1/s/frontend/pages/admin/profiles/index.vue?macro=true";
import { default as indeximwqsqpS7p4RXBMxy2mlioU8w0Ik_YML91cspJLNOgcMeta } from "/home/runner/work/1/s/frontend/pages/admin/qualifications/index.vue?macro=true";
import { default as indexuANTtbOBbhjfzsVy4q_sdvTSn612IpxWZBDlkzg9qdMMeta } from "/home/runner/work/1/s/frontend/pages/admin/reports/index.vue?macro=true";
import { default as indexQWGiWNqvKAl1zJi_0xdAWRDKVJQml9V1WwBIZAwGNj8Meta } from "/home/runner/work/1/s/frontend/pages/admin/service-alerts/index.vue?macro=true";
import { default as settingsf9Sh2zZYY2qwSwB_Dpoit7HJVC4F910J0usN4tz_DK4Meta } from "/home/runner/work/1/s/frontend/pages/admin/settings.vue?macro=true";
import { default as support5_1e6lYArrILyAw8FeqkfAZ33BRfNTlC_9YdoHJraaEMeta } from "/home/runner/work/1/s/frontend/pages/admin/support.vue?macro=true";
import { default as indexboYq7hzaKoGYYPnyAY_5CvyDarSRF4Hh6dTYGPH07qYMeta } from "/home/runner/work/1/s/frontend/pages/admin/teams/index.vue?macro=true";
import { default as indexviiYHPH7Szi3dFXppMDMUAV5NTyOKR7n_8Cp1pxuh7gMeta } from "/home/runner/work/1/s/frontend/pages/admin/themes/index.vue?macro=true";
import { default as editWoSm1cs_3V1gOhfH0bBP4LuMtgw618LtcghCcJvEkucMeta } from "/home/runner/work/1/s/frontend/pages/my-profile/edit.vue?macro=true";
import { default as optional6yyfwreBqoifgBtryUCfW4lL0xIWt7LJR7FSTnObwXsMeta } from "/home/runner/work/1/s/frontend/pages/my-profile/optional.vue?macro=true";
import { default as themesWbdi9w4P0aJfLxBMLFTLzMRvPQgDG3OPrNzxHG_hrmoMeta } from "/home/runner/work/1/s/frontend/pages/my-profile/themes.vue?macro=true";
import { default as _91id_93eHKzdDJEiBD2wO9rOC3FkVFOICTVCycvAfraSo9o81UMeta } from "/home/runner/work/1/s/frontend/pages/article/[id].vue?macro=true";
import { default as _91id_93_9PMqORS3KY_C_rkAmRStRkFD0QNm4A1DENVSH9ftEsMeta } from "/home/runner/work/1/s/frontend/pages/articles/[id].vue?macro=true";
import { default as account_45setup3Hr69esCYz9ztMmo6fLUW95LLs8YnJFMHp4YWIxpjQ8Meta } from "/home/runner/work/1/s/frontend/pages/account-setup.vue?macro=true";
import { default as indexWn9_8O0o8ecnxxq1cqAM3ap4tygfNg1WnyM3c6inX1oMeta } from "/home/runner/work/1/s/frontend/pages/articles/index.vue?macro=true";
import { default as callbackXxskQbq6HvcWelAiqh1_BAzXsoWLGmxid8loVLZ__3UMeta } from "/home/runner/work/1/s/frontend/pages/callback.vue?macro=true";
import { default as dashboardtuky_tuC7lRn_3ItuVHAGjPr9MCSoeXuaFALsg5wfJ8Meta } from "/home/runner/work/1/s/frontend/pages/dashboard.vue?macro=true";
import { default as logoutxsR60s8xkvPeY6D8w1clvl2h6G3LGTH0S6I5eAF6l00Meta } from "/home/runner/work/1/s/frontend/pages/logout.vue?macro=true";
import { default as indexp7tAQEFxkwbAN_wd3OSJVCDHFO72plKijb6slytsohkMeta } from "/home/runner/work/1/s/frontend/pages/my-profile/index.vue?macro=true";
export default [
  {
    name: "admin-employers-manage-id",
    path: "/admin/employers/manage/:id?",
    meta: _91_91id_93_9319htrayCNTex9aPfumHcKsBc_34JP8vSpIBtLFEu3CEMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/employers/manage/[[id]].vue")
  },
  {
    name: "admin-articles-create",
    path: "/admin/articles/create",
    meta: create5719UJD_j88x9dB2Dh007lz1sfQY9sA__BT3Mrgma8kMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/articles/create.vue")
  },
  {
    name: "admin-competencies-create",
    path: "/admin/competencies/create",
    meta: createucTY852iLmN7D4_SLHyljo4VH5jqiKRRGjZEliO6ZYgMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/competencies/create.vue")
  },
  {
    name: "admin-employees-create",
    path: "/admin/employees/create",
    meta: createIm_GiVlA_nUukvIm1vc6GgXzkFDhO6Mfnhnsa565tEEMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/employees/create.vue")
  },
  {
    name: "admin-employees-employee-settings",
    path: "/admin/employees/employee-settings",
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/employees/employee-settings.vue")
  },
  {
    name: "admin-modules-create",
    path: "/admin/modules/create",
    meta: createtMm_2tqsj5RynMocEzlUc25YnyBSQQG3z8q_BE40PhYMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/modules/create.vue")
  },
  {
    name: "admin-profiles-create",
    path: "/admin/profiles/create",
    meta: createDMot9l4hjglFEAPOYpgVPdSNfDuQF10RmihJcTu9YDQMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/profiles/create.vue")
  },
  {
    name: "admin-service-alerts-create",
    path: "/admin/service-alerts/create",
    meta: createLDN0qRYUp_bpptTvYdNHw_A66REkUV4ub_DriQh_aqoMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/service-alerts/create.vue")
  },
  {
    name: "admin-teams-create",
    path: "/admin/teams/create",
    meta: createt5DLF3TO1ouiXVSRq1pIApeOAyPf_8rgjqglBRsar9sMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/teams/create.vue")
  },
  {
    name: "admin-themes-create",
    path: "/admin/themes/create",
    meta: create_mt_0LE8ygHxRaXz9PasHnzi1RB_KJlOsSLZHrUrVqEMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/themes/create.vue")
  },
  {
    name: "admin-articles-id-update",
    path: "/admin/articles/:id()/update",
    meta: updateL4vPeULsxOspvgpGBXbc1jwIm1eW_bXOKcAzrdnClKYMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/articles/[id]/update.vue")
  },
  {
    name: "admin-articles-id-update-content",
    path: "/admin/articles/:id()/update-content",
    meta: update_45contentf8xFqXEWXWcktZO3bB_ZlbTbC0m0WL6QqVWwusz7hpMMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/articles/[id]/update-content.vue")
  },
  {
    name: "admin-employees-id-update",
    path: "/admin/employees/:id()/update",
    meta: updateCrUw6Ydki3oqvO_Ul1K2N_N_Le_n_LtJU47J1Id1LNwMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/employees/[id]/update.vue")
  },
  {
    name: "admin-profiles-id-update",
    path: "/admin/profiles/:id()/update",
    meta: update9kI3dhelXjvJnJZKs1TqB63gotfBYSjRADqoapJPFTcMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/profiles/[id]/update.vue")
  },
  {
    name: "admin-teams-id-update",
    path: "/admin/teams/:id()/update",
    meta: updateCoyWAe55kSjjDw_sF0uQBVpWFMRY1nztCmnfA88McwsMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/teams/[id]/update.vue")
  },
  {
    name: "admin-themes-id-update",
    path: "/admin/themes/:id()/update",
    meta: updateKqhZl7xNHjgVSb4FGm2qTTkckPTLzqVrc8SASASgIOAMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/themes/[id]/update.vue")
  },
  {
    name: "admin-articles-id",
    path: "/admin/articles/:id()",
    meta: indexwD58owSLlYnze579DZ4pxNp9mWhf3VKw6nF2Ynecpc4Meta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/articles/[id]/index.vue")
  },
  {
    name: "admin-competencies-id",
    path: "/admin/competencies/:id()",
    meta: indexHWvCM0ZjVjfK4f_ir7rEN2Uvc6IbpjkHPsOFgES5LUwMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/competencies/[id]/index.vue")
  },
  {
    name: "admin-employees-id",
    path: "/admin/employees/:id()",
    meta: indexO4WW5nBlpaRi5XAD6s52DlIDN33x03D562lNF6qx8ZwMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/employees/[id]/index.vue")
  },
  {
    name: "admin-employers-id",
    path: "/admin/employers/:id()",
    meta: index2HTT_eeiz_MuD_pY2q9nj8v53mnUmBmTTE2nj2sSSAoMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/employers/[id]/index.vue")
  },
  {
    name: "admin-modules-id",
    path: "/admin/modules/:id()",
    meta: indexc5V7nIPe2j_CJZsk8BzmV_vNpIyNVqRynjlJ3eOIZoMMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/modules/[id]/index.vue")
  },
  {
    name: "admin-profiles-id",
    path: "/admin/profiles/:id()",
    meta: index8q28sfFpKtAJr1_YEHhzn7FIuQNklZZwu3qmAftdbB0Meta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/profiles/[id]/index.vue")
  },
  {
    name: "admin-teams-id",
    path: "/admin/teams/:id()",
    meta: indexl__6rYYdaIiVbJJ5j7VlOCAqJCNcvilfsGXK6iwYNmgMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/teams/[id]/index.vue")
  },
  {
    name: "admin-themes-id",
    path: "/admin/themes/:id()",
    meta: indexKOp6Bd0y9sPqxrrAJxqYMv9rp7T8CP5kmGEA9EticZUMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/themes/[id]/index.vue")
  },
  {
    name: "admin-articles",
    path: "/admin/articles",
    meta: indexIkSIVMe27bJcx9VN_xTXtyG_vwAG8T0qIVOo2a_KVGwMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/articles/index.vue")
  },
  {
    name: "admin-certificates",
    path: "/admin/certificates",
    meta: certificatesO5wrK9b9aehFBmfxrrCcB_9u7vd9nAmijeLQPaz8yosMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/certificates.vue")
  },
  {
    name: "admin-competencies",
    path: "/admin/competencies",
    meta: indexeV2abE7w_QTH4_NnNMs6DktPBHoFQojuYIqWVBac6kQMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/competencies/index.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    meta: dashboardhT4IDVJtvjBhBa4NDjaQcWXYi08m6yNhty0cIYodynAMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/dashboard.vue")
  },
  {
    name: "admin-employees",
    path: "/admin/employees",
    meta: indexcmHGB_jQnT8FpJJOGplDtLXkb5ESYi45Q7tzJKdT3k4Meta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/employees/index.vue")
  },
  {
    name: "admin-employers",
    path: "/admin/employers",
    meta: indexLV0afBeYJV03aQY_rw7IG_oOM6o6SDZAy2kuSwXtSQUMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/employers/index.vue")
  },
  {
    name: "admin-faq",
    path: "/admin/faq",
    meta: faqmLegsHaIQrjySbLMqYvSOiYtxkm2dAgWFa2zxWuqUVsMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/faq.vue")
  },
  {
    name: "admin-lamark",
    path: "/admin/lamark",
    meta: indexR04DT8Ex0ZuH4jxTMFoZ4H51YWXY12hB3WllPRuKxRsMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/lamark/index.vue")
  },
  {
    name: "admin-modules",
    path: "/admin/modules",
    meta: indexywIAgmhnenu3qTqDwCoQ_fAe8PJ0QIv05CjtixOZZxgMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/modules/index.vue")
  },
  {
    name: "admin-my-employer",
    path: "/admin/my-employer",
    meta: my_45employerp_WFBqRPkN4z5HyGs8DX7Lp9sObbPr8_eLSTG_81AX4Meta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/my-employer.vue")
  },
  {
    name: "admin-profiles",
    path: "/admin/profiles",
    meta: indexaXzVoCJV4AOP7RSaF6AkZZRXGjZ5CV0CWhTYC_KyeBYMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/profiles/index.vue")
  },
  {
    name: "admin-qualifications",
    path: "/admin/qualifications",
    meta: indeximwqsqpS7p4RXBMxy2mlioU8w0Ik_YML91cspJLNOgcMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/qualifications/index.vue")
  },
  {
    name: "admin-reports",
    path: "/admin/reports",
    meta: indexuANTtbOBbhjfzsVy4q_sdvTSn612IpxWZBDlkzg9qdMMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/reports/index.vue")
  },
  {
    name: "admin-service-alerts",
    path: "/admin/service-alerts",
    meta: indexQWGiWNqvKAl1zJi_0xdAWRDKVJQml9V1WwBIZAwGNj8Meta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/service-alerts/index.vue")
  },
  {
    name: settingsf9Sh2zZYY2qwSwB_Dpoit7HJVC4F910J0usN4tz_DK4Meta?.name,
    path: "/admin/settings",
    meta: settingsf9Sh2zZYY2qwSwB_Dpoit7HJVC4F910J0usN4tz_DK4Meta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/settings.vue"),
    children: [
  {
    name: "admin-settings-export-users",
    path: "export-users",
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/settings/export-users.vue")
  },
  {
    name: "admin-settings",
    path: "",
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/settings/index.vue")
  }
]
  },
  {
    name: "admin-support",
    path: "/admin/support",
    meta: support5_1e6lYArrILyAw8FeqkfAZ33BRfNTlC_9YdoHJraaEMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/support.vue")
  },
  {
    name: "admin-teams",
    path: "/admin/teams",
    meta: indexboYq7hzaKoGYYPnyAY_5CvyDarSRF4Hh6dTYGPH07qYMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/teams/index.vue")
  },
  {
    name: "admin-themes",
    path: "/admin/themes",
    meta: indexviiYHPH7Szi3dFXppMDMUAV5NTyOKR7n_8Cp1pxuh7gMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/themes/index.vue")
  },
  {
    name: "my-profile-edit",
    path: "/my-profile/edit",
    meta: editWoSm1cs_3V1gOhfH0bBP4LuMtgw618LtcghCcJvEkucMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/my-profile/edit.vue")
  },
  {
    name: "my-profile-optional",
    path: "/my-profile/optional",
    meta: optional6yyfwreBqoifgBtryUCfW4lL0xIWt7LJR7FSTnObwXsMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/my-profile/optional.vue")
  },
  {
    name: "my-profile-themes",
    path: "/my-profile/themes",
    meta: themesWbdi9w4P0aJfLxBMLFTLzMRvPQgDG3OPrNzxHG_hrmoMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/my-profile/themes.vue")
  },
  {
    name: "screenshot-pdf",
    path: "/screenshot/pdf",
    component: () => import("/home/runner/work/1/s/frontend/pages/screenshot/pdf.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    meta: _91id_93eHKzdDJEiBD2wO9rOC3FkVFOICTVCycvAfraSo9o81UMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/article/[id].vue")
  },
  {
    name: "articles-id",
    path: "/articles/:id()",
    meta: _91id_93_9PMqORS3KY_C_rkAmRStRkFD0QNm4A1DENVSH9ftEsMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/articles/[id].vue")
  },
  {
    name: "403",
    path: "/403",
    component: () => import("/home/runner/work/1/s/frontend/pages/403.vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/home/runner/work/1/s/frontend/pages/404.vue")
  },
  {
    name: "423",
    path: "/423",
    component: () => import("/home/runner/work/1/s/frontend/pages/423.vue")
  },
  {
    name: "account-error",
    path: "/account-error",
    component: () => import("/home/runner/work/1/s/frontend/pages/account-error.vue")
  },
  {
    name: "account-setup",
    path: "/account-setup",
    meta: account_45setup3Hr69esCYz9ztMmo6fLUW95LLs8YnJFMHp4YWIxpjQ8Meta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/account-setup.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/home/runner/work/1/s/frontend/pages/admin/index.vue")
  },
  {
    name: "articles",
    path: "/articles",
    meta: indexWn9_8O0o8ecnxxq1cqAM3ap4tygfNg1WnyM3c6inX1oMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/articles/index.vue")
  },
  {
    name: "callback",
    path: "/callback",
    meta: callbackXxskQbq6HvcWelAiqh1_BAzXsoWLGmxid8loVLZ__3UMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/callback.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardtuky_tuC7lRn_3ItuVHAGjPr9MCSoeXuaFALsg5wfJ8Meta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/dashboard.vue")
  },
  {
    name: "loggedout",
    path: "/loggedout",
    component: () => import("/home/runner/work/1/s/frontend/pages/loggedout.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutxsR60s8xkvPeY6D8w1clvl2h6G3LGTH0S6I5eAF6l00Meta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/logout.vue")
  },
  {
    name: "my-profile",
    path: "/my-profile",
    meta: indexp7tAQEFxkwbAN_wd3OSJVCDHFO72plKijb6slytsohkMeta || {},
    component: () => import("/home/runner/work/1/s/frontend/pages/my-profile/index.vue")
  }
]